import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Estado del sidebar de navegación (colapsado/expandido), persistido como
 * preferencia del usuario. Compartido por `Sidebar` (ancho) y `AppShell`
 * (desplazamiento del contenido) para mantenerlos en sync.
 */
type SidebarState = {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (v: boolean) => void;
};

export const useSidebar = create<SidebarState>()(
  persist(
    (set) => ({
      collapsed: false,
      toggle: () => set((s) => ({ collapsed: !s.collapsed })),
      setCollapsed: (v: boolean) => set({ collapsed: v }),
    }),
    { name: 'mb-sidebar-collapsed' },
  ),
);
